import React, {useState} from "react";
import {Container} from "./LayoutHelpers";
import {Compa} from "./Compa";

const SITE = {
    name: "COMPASSIA",
    domain: "https://compassia.es",
    email: "info@compassia.es",
    phone: "+34 600 000 000",
    city: "Barcelona",
    country: "España",
    tagline: "Optimización sin fricción",
    description:
        "Automatizamos y optimizamos procesos con tu stack actual. Pilotos de 2–4 semanas con objetivos medibles. Integraciones n8n, RAG privado en AWS, Leads/CRM, contratos y aprobaciones, onboarding/offboarding y reporting.",
    keywords:
        "automatización PYMES, n8n, RAG privado, AWS, NetSuite, integración ERP CRM, IA aplicada, dashboards KPIs, gestión de agenda, clasificación de leads, firma electrónica, aprobaciones, onboarding, reporting, proyectos a medida",
    ogImage: "/og-compassia.jpg",
    twitter: "@compassia",
};

export function Navbar() {
    const [open, setOpen] = useState(false);
    const links = [
        { href: "/#servicios", label: "Servicios" },
        { href: "/#custom", label: "Proyecto a medida" },
        { href: "/#proceso", label: "Proceso" },
        { href: "/#faq", label: "FAQ" },
        { href: "/#contacto", label: "Contacto" },
    ];
    return (
        <header className="nav" role="banner">
            <Container className="nav-inner">
                <a href="/#inicio" className="brand" aria-label="Volver al inicio">
                    <Compa size={40} />
                    <div className="brand-text">
                        <div className="brand-title">COMPASSIA</div>
                        <div className="brand-tagline">{SITE.tagline}</div>
                    </div>
                </a>

                <nav className={`menu ${open ? "is-open" : ""}`} aria-label="Principal">
                    {links.map((l) => (
                        <a key={l.href} href={l.href} className="menu-link" onClick={() => setOpen(false)}>
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="nav-cta">
                    <a href="/#contacto" className="btn-primary btn-small">Hablemos</a>
                    <button className="hamburger" aria-label="Abrir menú" onClick={() => setOpen(v => !v)}>
                        <span /><span /><span />
                    </button>
                </div>
            </Container>
        </header>
    );
}
